import React from 'react';
import { BarChart3, Users, FileText, MessageSquare } from 'lucide-react';

const Dashboard: React.FC = () => {
  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold text-gray-900 mb-8">Dashboard</h1>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        {/* Stats Cards */}
        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-gray-500 text-sm">Total Clients</p>
              <p className="text-2xl font-bold text-gray-900">128</p>
            </div>
            <Users className="text-blue-500 h-8 w-8" />
          </div>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-gray-500 text-sm">Active Contracts</p>
              <p className="text-2xl font-bold text-gray-900">85</p>
            </div>
            <FileText className="text-green-500 h-8 w-8" />
          </div>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-gray-500 text-sm">Pending Messages</p>
              <p className="text-2xl font-bold text-gray-900">12</p>
            </div>
            <MessageSquare className="text-yellow-500 h-8 w-8" />
          </div>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-gray-500 text-sm">Monthly Revenue</p>
              <p className="text-2xl font-bold text-gray-900">$24,500</p>
            </div>
            <BarChart3 className="text-purple-500 h-8 w-8" />
          </div>
        </div>
      </div>

      {/* Recent Activity */}
      <div className="bg-white rounded-lg shadow p-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">Recent Activity</h2>
        <div className="space-y-4">
          {[
            { action: "New contract signed", client: "John Doe", time: "2 hours ago" },
            { action: "Message received", client: "Jane Smith", time: "4 hours ago" },
            { action: "Contract updated", client: "Robert Johnson", time: "6 hours ago" },
          ].map((activity, index) => (
            <div key={index} className="flex items-center justify-between py-2 border-b last:border-0">
              <div>
                <p className="text-gray-900">{activity.action}</p>
                <p className="text-sm text-gray-500">{activity.client}</p>
              </div>
              <span className="text-sm text-gray-500">{activity.time}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;